/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_Error_LimitInputs */

const fr_membership_friend_guest_error_limit = /** @type {(inputs: Membership_Friend_Guest_Error_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà invité un ami ce mois-là.`)
};

/**

* @param {Membership_Friend_Guest_Error_LimitInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_error_limit = /** @type {((inputs?: Membership_Friend_Guest_Error_LimitInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_Error_LimitInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_error_limit(inputs)
});